// extracted by mini-css-extract-plugin
export default {"Groups":"_Groups--zxvl9","Name":"_Name--s_pN6","Buttons":"_Buttons--n967M","ContentHeader":"_ContentHeader--YTub_"};